<div class="lei-wrapper">
  <h2>Legal Entity Information</h2>
  <p *ngIf="!entityId">Select a legal entity to view details.</p>
  <div *ngIf="entityId">
    <p><strong>ID:</strong> {{ entityId }}</p>
    <p class="placeholder">Details placeholder for {{ entityId }}.</p>
  </div>
</div>
